/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
// axios
import axios from "../axios.js";
// Router
import router from "../router.js";

import store from "./store.js";

axios.interceptors.request.use(
  async function(config) {
    // Do something before request is sent
    const { accessToken } = store.getters;
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  async function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  async function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function(error) {
    await console.log("test error", error);
    // $vs.notify({
    //   title: 'Error!',
    //   text: 'test talkfjsdl fl sdflkjs dlf ',
    //   color: "danger",
    //   position: 'top-right'
    // })
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    const originalRequest = error.config;
    if (
      error.response.status === 401 &&
      originalRequest.url.includes("auth/hq-user/refresh")
    ) {
      // store.commit('clearUserData')
      await store.dispatch("apiLoading", false);
      router.push("/pages/login");
      return Promise.reject(error);
    } else if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      await store.dispatch("refreshToken");
      return axios(originalRequest);
    }
    if (error.response.data) {
      store.dispatch("apiError", error.response.data.error);
    }
    return Promise.reject(error);
  }
);

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit("UPDATE_USER_INFO", payload);
  },
  // /////////////////////////////////////////////
  // loading and error
  // /////////////////////////////////////////////
  apiLoading: async ({ commit }, payload) => {
    commit("SET_LOADING", payload);
  },
  apiError: async ({ commit }, payload) => {
    commit("SET_ERROR", payload);
  },

  // /////////////////////////////////////////////
  // Fatch API
  // /////////////////////////////////////////////

  loginUser: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    await axios
      .post("auth/hq-user/login", payload)
      .then(res => {
        const {
          access_token,
          refresh_toke,
          user_info,
          user_role
        } = res.data.success;
        const userDefaults = {
          uid: payload.user_id, // From Auth
          displayName: payload.user_id, // From Auth
          about:
            "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
          photoURL: require("@/assets/images/portrait/small/ava.png"), // From Auth
          status: "online",
          userRole: user_role,
          user_info: user_info
        };
        commit("SET_REFRESH_TOKEN", refresh_toke);
        commit("SET_ACCESS_TOKEN", access_token);
        commit("UPDATE_USER_INFO", userDefaults);
        commit("SET_LOADING", false);
        router.push({ name: "home" });
      })
      .catch(function(error) {
        window.alert("Please Enter valid Username and Password.");
        commit("SET_LOADING", false);
      });
  },
  refreshToken: async ({ state, commit }) => {
    await commit("SET_LOADING", true);
    const refreshUrl = "auth/hq-user/refresh";
    let config = {
      headers: {
        Authorization: `Bearer ${state.refreshToken}`
      }
    };
    try {
      await axios.post(refreshUrl, {}, config).then(response => {
        if (response.status === 200) {
          commit("SET_ACCESS_TOKEN", response.data.success.access_token);
        }
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getAllUser: async ({ commit }) => {
    await commit("SET_LOADING", true);
    try {
      await axios.get("hq-users").then(response => {
        if (response.status === 200) {
          commit("SET_USERS", response.data.success);
        }
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  createUser: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.post("hq-user", payload).then(response => {
        commit("SET_AN_USER", payload);
        commit("SET_LOADING", false);
        router.push({ name: "users" });
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  updateUser: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.put("hq-user", payload).then(response => {
        commit("SET_AN_USER", payload);
        commit("SET_LOADING", false);
        router.push({ name: "users" });
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getVierOnlyUserACL: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.get(`hq-user/acl?user_id=${payload}`).then(response => {
        commit("SET_VIEW_ONLY_USER_ACL", response.data.success.suffix_acl);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  /* getViewOnlyUserACLFootfall: async ({ commit }, payload) => {
    await commit('SET_LOADING', true);
    try {
      payload.suffix = payload.suffix.toString();
      console.log("---->",payload);
      await axios.post('footfall', payload)
        .then(response => {
          commit('SET_VIEW_ONLY_USER_ACL_FOOTFALL', response.data)
          commit('SET_LOADING', false)
        })
      payload.suffix = payload.suffix.split(",");
    } catch (e) {
      commit('SET_LOADING', false)
    }
  },*/
  getViewOnlyUserACLFootfall: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      payload.suffix = payload.suffix.toString();
      const footfallData = {
        url: "footfall",
        data: payload
      };
      await axios.post("proxy", footfallData).then(response => {
        commit("SET_VIEW_ONLY_USER_ACL_FOOTFALL", response.data);
        commit("SET_LOADING", false);
      });
      payload.suffix = payload.suffix.split(",");
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getViewOnlyUserACLAnalytics: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      payload.suffix = payload.suffix.toString();
      const analyticsData = {
        url: "analytics",
        data: payload
      };
      await axios.post("proxy", analyticsData).then(response => {
        commit("SET_VIEW_ONLY_USER_ACL_ANALYTICS", response.data);
        //ex
        let propertyNames = Object.keys(response.data.data);
        console.log(propertyNames);
        let appArr = [];
        for (let i = 0; i < propertyNames.length; i++) {
          //console.log(i, propertyNames[i]);
          let suf = propertyNames[i].toString();
          const sin = response.data.data[propertyNames[i]];
          //console.log(i, sin);
          if(sin.length > 0){
            sin.forEach(el => {
              console.log("Extr =", el);
              el.suffix = suf;
              el.status = el.status === 2? "New Application" : el.status === 3? "In-Process" : el.status === 4? "Halt"
                  : el.status === 5? "Accepted": el.status === 6? "Rejected" : el.status === 7? "Reviewed": "";
              appArr.push(el)
            })
          }

        }
        commit("SET_DOWNLOAD_ANALYTICS", appArr);
        console.log("~~~~~~~~", appArr);
        //ex
        commit("SET_LOADING", false);
      });
      payload.suffix = payload.suffix.split(",");
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  //analytics Download start
  downloadanalytics: async ({ commit }, payload) => {
    console.log("Payload 2 =", payload);
    const pass = [];
    payload.forEach(v => {
      console.log("Payload For Each", v);
      pass.push(v);
    });
    console.log("Payload For Each Last", pass);
    await commit("SET_LOADING", true);
    try {
      axios({
        url: 'https://ho.butterflygroupbd.com/showroom-backend/api/downloadAnalyticsData',
        data:pass,
        method: 'POST',
        responseType: 'blob', // important

      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'analytics.xlsx');
        document.body.appendChild(link);
        link.click();
        commit("SET_LOADING", false);
      });
      //payload.suffix = payload.suffix.split(",");
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  //analytics Download end

  createVierOnlyUserACL: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.post("hq-user/acl", payload).then(response => {
        commit("SET_VIEW_ONLY_USER_ACL", response.data.success.suffix_acl);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  updateVierOnlyUserACL: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.put("hq-user/acl", payload).then(response => {
        window.alert("Successfully Updated.");
        if (response.data.success.message === "NOT OK") {
          try {
            axios.post("hq-user/acl", payload).then(response => {
              commit(
                "SET_VIEW_ONLY_USER_ACL",
                response.data.success.suffix_acl
              );
              commit("SET_LOADING", false);
              window.alert("Successfully Saved.");
            });
          } catch (e) {
            commit("SET_LOADING", false);
          }
        }
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getShowrooms: async ({ commit }) => {
    await commit("SET_LOADING", true);
    try {
      await axios.get("showrooms").then(response => {
        if (response.status === 200) {
          commit("SET_SHOWROOMS", response.data.success);
          commit("SET_LOADING", false);
        }
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  createShowroom: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      // console.log('showroom', payload)
      const showroom = {
        url: "showrooms",
        data: {
          emp_id: payload.manager_emp_id,
          phone: payload.mobile,
          division: payload.division,
          district: payload.district,
          suffix: payload.suffix,
          manager_name: payload.manager_name,
          email: payload.email,
          password: payload.password,
          address: payload.address
        }
      };
      await axios.post("proxy", showroom).then(res => {
        axios.post("showroom", payload).then(response => {
          commit("SET_A_SHOWROOM", payload);
          commit("SET_LOADING", false);
          router.push({ name: "showroom" });
        });
      });
    } catch (e) {
      console.log("Error = ", e);
      commit("SET_LOADING", false);
    }
  },
  updateShowroom: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      const showroom = {
        url: "showrooms/" + payload.suffix,
        data: {
          emp_id: payload.manager_emp_id,
          phone: payload.mobile,
          division: payload.division,
          district: payload.district,
          manager_name: payload.manager_name,
          email: payload.email,
          password: payload.password,
          address: payload.address
        }
      };
      await axios.put("proxy", showroom).then(res => {
        axios.put("showroom", payload).then(response => {
          commit("SET_A_SHOWROOM", payload);
          commit("SET_LOADING", false);
          router.push({ name: "showroom" });
        });
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getApplicantList: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`proxy?url_path=${encodeURIComponent(payload)}`)
        .then(response => {
          commit("SET_APPLICANT_LIST", response.data.data);
          commit("SET_LINK", response.data.links);
          commit("SET_META", response.data.meta);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getApplicant: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.get(`proxy?url_path=applicant/${payload}`).then(response => {
        commit("SET_APPLICANT", response.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  updateApplicant: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    const data = {
      url: `applicant/${payload.id}`,
      data: payload.data
    };
    try {
      await axios.put(`proxy`, data).then(response => {
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
      window.alert("The phone has already been taken.");
    }
  },
  getGaurantorList: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`proxy?url_path=guarantors${encodeURIComponent(payload)}`)
        .then(response => {
          commit("SET_GAURANTOR_LIST", response.data.data);
          commit("SET_LINK", response.data.links);
          commit("SET_META", response.data.meta);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getGuarantor: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.get(`proxy?url_path=guarantor/${payload}`).then(response => {
        commit("SET_GAURANTOR", response.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getApplicationList: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    console.log("========+++++++++++++++=====", payload)

    try {
      await axios
        .get(`proxy?url_path=applications${encodeURIComponent(payload)}`)
        .then(response => {
          commit("SET_APPLICATION_LIST", response.data.data);
          console.log("========+++++++++++++++=====2", payload);
          console.log("Muu---------------------")
          commit("SET_LINK", response.data.links);
          commit("SET_META", response.data.meta);
          commit("SET_LOADING", false);
          console.log("=========", response.data.data)
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getNewApplicationList: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    console.log("========+++++++++++++++=====", payload)
    try {
      await axios
        .get(`https://ho.butterflygroupbd.com/showroom-backend/api/hoNewApplication/${payload}`)
        .then(response => {
         /* commit("SET_APPLICATION_LIST", response.data.data);
          console.log("========+++++++++++++++=====2", payload);
          console.log("Muu---------------------")
          commit("SET_LINK", response.data.links);
          commit("SET_META", response.data.meta);
          commit("SET_LOADING", false);*/
          console.log("=========", response.data.data)
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getBlockedApplByValidateStatus: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`https://ho.butterflygroupbd.com/showroom-backend/api/getEkyc_validate_by_nid/${payload}`)
        .then(response => {
          commit("SET_BLOCKED_APPLICATION_LIST", response.data);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  searchBlockedApplListByValidateStatus: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`https://ho.butterflygroupbd.com/showroom-backend/api/getEkyc_block_list_by_nid/3/${payload}`)
        .then(response => {
          commit("SET_BLOCKED_APPLICATION_LIST", response.data);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getApplication: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`proxy?url_path=application/${payload}`)
        .then(response => {
          commit("SET_APPLICATION", response.data);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  updateApplication: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    // obj = {id:applicationId, data{status: 7, comment: "string"}}
    const data = {
      url: `application/${payload.id}`,
      data: payload.data
    };
    try {
      await axios.put(`proxy`, data).then(response => {
        commit("SET_APPLICATION", response.data);
        commit("SET_LOADING", false);
        router.push({ name: "application" });
      });
    } catch (e) {
      commit("SET_LOADING", false);

    }
  },
  getProductMasterList: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`proxy?url_path=productmasters${encodeURIComponent(payload)}`)
        .then(response => {
          commit("SET_PRODUCT_MASTER_LIST", response.data.data);
          commit("SET_LINK", response.data.links);
          commit("SET_META", response.data.meta);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getDashboardData: async ({ commit }) => {
    await commit("SET_LOADING", true);
    try {
      await axios.get(`proxy?url_path=dashboard`).then(response => {
        commit("SET_DASHBOARD_DATA_LIST", response.data.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getUpdateProductMasterManually: async ({ commit }) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`proxy?url_path=productmasters-manual-update`)
        .then(response => {
          setTimeout(() => {
            commit("SET_LOADING", false);
          }, 15000);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getWashingMachineTrail: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`proxy?url_path=${encodeURIComponent(payload)}`)
        //await axios.get(`proxy?url_path=${payload}`)
        .then(response => {
          commit("SET_WASHING_MACHINE_TRAIL", response.data.data);
          commit("SET_LINK", response.data.links);
          commit("SET_META", response.data.meta);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getWNTrialById: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.get(`proxy?url_path=trial/${payload}`).then(response => {
        commit("SET_WM_TRIAL_BY_ID", response.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
/*  uploadExcel: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    console.log("PostExcel file payload= ", payload);
    try {
      await axios.post("https://ho.butterflygroupbd.com/showroom-backend/api/compare", payload).then(res => {
        console.log("PostExcel file = ", res.data);
        commit("SET_COMPARE_DATA", res.data.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      console.log("Error = ", e);
      commit("SET_LOADING", false);
    }
  },*/
  uploadExcel: async ({ commit }, payload) => {
    commit('SET_EXCEL_UPLOAD_LOADING', true);
    console.log('PostExcel file payload= ', payload);
    try {
      await axios
        .post('https://ho.butterflygroupbd.com/showroom-backend/api/importExcel', payload)
        // .post('http://showroom.test:82/api/importExcel', payload)
        .then((res) => {
          console.log('PostExcel file = ', res.data);
          commit('SET_COMPARE_DATA', res.data);
          commit('SET_EXCEL_UPLOAD_LOADING', false);
          commit('SET_EXCEL_UPLOAD_DONE', true)
        })
    } catch (e) {
      console.log('Error = ', e);
      commit('SET_LOADING', false)
    }
  },
  compareDataForExcel: async ({ commit }) => {
    commit('SET_COMPARE_EXCEL_LOADING', true);
    try {
      await axios
        .get('https://ho.butterflygroupbd.com/showroom-backend/api/allCompare')
        .then((res) => {
          console.log('res.data => ', res.data);
          //commit('SET_COMPARE_DATA', res.data)
          commit('SET_COMPARE_EXCEL_LOADING', false);
          commit('SET_COMPARE_EXCEL_DONE', true);
          commit('SET_EXCEL_UPLOAD_LOADING', false);
          commit('SET_EXCEL_UPLOAD_DONE', false)
        })
    } catch (e) {
      commit('SET_LOADING', false)
    }
  },
  getAllCompareList: async ({ commit }, payload) => {
    console.log('----------', payload)
    try {
      await axios
        .get(`https://ho.butterflygroupbd.com/showroom-backend/api/allCompareDataList?page=${payload}`)
        .then((res) => {
          console.log('res.data => ', res.data)
          commit('SET_COMPARE_DATA', res.data)
          //commit("SET_LOADING", false);
        })
    } catch (e) {
      commit('SET_LOADING', false)
    }
  },

  getExcel: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.get("https://ho.butterflygroupbd.com/showroom-backend/api/compare"+payload).then(res => {
        console.log("getExcel file = ", res.data);
        commit("SET_COMPARE_DATA", res.data.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      console.log("Error = ", e);
      commit("SET_LOADING", false);
    }
  },
  searchExcelData: async ({ commit }, payload) => {
    console.log("Action Payload = ", payload)
    await commit("SET_LOADING", true);
    try {
      await axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/compare?${payload}`).then(response => {
        commit("SET_COMPARE_DATA", response.data.data.data);
        console.log("Action Response = ", response.data.data)
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  compleateReview: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/compare/${payload}`).then(response => {
        console.log("Action Response = ", response.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
      return e.response.data;
    }
  },
  sendReview: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.put(`https://ho.butterflygroupbd.com/showroom-backend/api/compare/${payload.id}`, {review: payload.review}).then(response => {
        console.log("Action Response = ", response.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
      return e.response.data;
    }
  },
  sendMailForIncApp: async ({ commit }, payload) => {
    console.log("Action Payload = ", payload)
    await commit("SET_LOADING", true);
    try {
      await axios.get(`proxy?url_path=incompletenotify/${payload}`).then(response => {
        console.log("Action Response = ", response.data.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  profileUpdate: async ({ commit }) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`https://ho.butterflygroupbd.com/showroom-backend/api/updaterequests`)
        .then(response => {
          console.log("===v", response.data.data)
          commit("SET_PROFILE_UPDATE_DATA", response.data.data);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  profileSearch: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`https://ho.butterflygroupbd.com/showroom-backend/api/updaterequests?search=${payload}`)
        .then(response => {
          commit("SET_PROFILE_UPDATE_DATA", response.data.data);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  profileDetails: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios
        .get(`https://ho.butterflygroupbd.com/showroom-backend/api/updaterequest/${payload}`)
        .then(response => {
          console.log("===v", response.data.data)
          commit("SET_PROFILE_DETAILS", response.data.data);
          commit("SET_LOADING", false);
        });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  acceptOrRejectProfile: async ({ commit }, payload) => {
    await commit("SET_LOADING", true);
    try {
      await axios.put("https://ho.butterflygroupbd.com/showroom-backend/api/updaterequest", payload).then(res => {
        console.log("PostExcel file = ", res.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      console.log("Error = ", e);
      commit("SET_LOADING", false);
    }
  },
  deleteUser: async ({ commit }, payload) => {
    console.log('Delete Id= ', payload);
    try {
      await axios
        .post('https://ho.butterflygroupbd.com/showroom-backend/api/deleteApplicant', payload)
        .then((res) => {
          console.log('PostExcel file = ', res.data);
          commit("SET_LOADING", false);
        })
    } catch (e) {
      console.log('Error = ', e);
      commit('SET_LOADING', false)
    }
  },
  getChangeReqApplLists: async ({ commit}, payload ) => {
    commit("SET_LOADING", true);
    try {
      console.log("pay", payload)
      await axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/getAllChangeRequestByStatusForHo/${payload}`).then(response => {
        console.log("submmission",response.data)
        commit("SET_CHANGE_REQ_APPL", response.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getApplicationByStatus: async ({ commit}, payload ) => {
    commit("SET_LOADING", true);
    try {
      console.log("pay", payload)
      //await axios.get(`http://showroom.test:82/api/filterApplicationByParam/${payload}`).then(response => {
      await axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/filterApplicationByParam/${payload}`).then(response => {
        console.log("submmission",response.data)
        commit("SET_CHANGE_REQ_APPL", response.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  getProfileUpdateReqForPersonalInfo: async ({ commit} ) => {
    commit("SET_LOADING", true);
    try {
      await axios.get(`${API_URL}/getApplicantPersonalUpdateLogInfo`).then(response => {
        console.log("=================", response);
        commit("SET_APPLICANT_PERSONAL_PRO_UPDATE", response.data);
        commit("SET_LOADING", false);
      });
    } catch (e) {
      commit("SET_LOADING", false);
    }
  },
  logout: async ({ commit }) => {
    await commit("SET_ACCESS_TOKEN", "");
    await commit("SET_REFRESH_TOKEN", "");
    await commit("UPDATE_USER_INFO", null);
    await location.reload();
  }
};

export default actions;
